import { reactive } from 'vue'

const state = reactive({
  permissions: [],
  role: null
})

export const ability = {
  get permissions() {
    return state.permissions
  },
  
  get role() {
    return state.role
  },

  setPermissions(permissions) {
    state.permissions = permissions
  },

  setRole(role) {
    state.role = role
  },

  can(action, subject) {
    // Check if user is super_admin first
    const userData = localStorage.getItem('user_data');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        if (user.super_admin === true) {
          return true; // Super admin can do everything
        }
      } catch (e) {
        console.error('Error parsing user_data in ability.can:', e);
      }
    }
    
    // Check if user has the specific permission
    if (state.permissions && state.permissions.length > 0) {
      // Check for exact match: action + subject
      const hasExactPermission = state.permissions.some(permission => {
        return permission.action === action && permission.subject === subject;
      });
      
      if (hasExactPermission) {
        return true;
      }
      
      // Check for "manage all" permission
      const hasManageAll = state.permissions.some(permission => {
        return permission.action === 'manage' && permission.subject === 'all';
      });
      
      if (hasManageAll) {
        return true;
      }
      
      // Check for "manage" on specific subject (manage implies all actions)
      if (action !== 'manage') {
        const hasManageSubject = state.permissions.some(permission => {
          return permission.action === 'manage' && permission.subject === subject;
        });
        
        if (hasManageSubject) {
          return true;
        }
      }
    }
    
    return false;
  },

  // Initialize from user data
  update(user) {
    if (user) {
      this.setRole(user.role_name || user.role || (user.admin ? 'admin' : 'user'))
      // Set permissions from user data
      if (user.permissions && Array.isArray(user.permissions)) {
        this.setPermissions(user.permissions)
      }
    }
  }
}

export default {
  install: (app) => {
    app.config.globalProperties.$can = (action, subject) => ability.can(action, subject)
    app.provide('ability', ability)
  }
}
